/**
 * Mirrors PaymentMethodStatus's vocabulary and lowercase style, narrowed to the
 * two states a cached resolution can be in. EXPIRED is the retire-without-
 * deleting state: reads skip it, and a fresh live resolve flips it back to
 * ACTIVE. Same semantic the NG payment_methods pre-check used with
 * `status: {$nin: [PaymentMethodStatus.EXPIRED]}` before it was removed.
 *
 * In core because the admin resolution-cache screen filters and branches on it.
 */
export var PaymentMethodNameResolutionStatus;
(function (PaymentMethodNameResolutionStatus) {
    PaymentMethodNameResolutionStatus["ACTIVE"] = "active";
    PaymentMethodNameResolutionStatus["EXPIRED"] = "expired";
})(PaymentMethodNameResolutionStatus || (PaymentMethodNameResolutionStatus = {}));
/**
 * Whether a cached resolution is actually replayed, which `status` alone does
 * not say: an ACTIVE row is skipped once it is older than the freshness window
 * (STALE) or when its resolver is no longer on the trusted allowlist
 * (UNTRUSTED). Derived on read for the admin screen, never stored.
 */
export var PaymentMethodNameResolutionCacheState;
(function (PaymentMethodNameResolutionCacheState) {
    PaymentMethodNameResolutionCacheState["SERVED"] = "served";
    PaymentMethodNameResolutionCacheState["STALE"] = "stale";
    PaymentMethodNameResolutionCacheState["UNTRUSTED"] = "untrusted";
    PaymentMethodNameResolutionCacheState["EXPIRED"] = "expired";
})(PaymentMethodNameResolutionCacheState || (PaymentMethodNameResolutionCacheState = {}));
//# sourceMappingURL=PaymentMethodNameResolutionStatus.js.map